import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import AppLayout from "./components/AppLayout";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import ProjectNew from "./pages/ProjectNew";
import ProjectDetail from "./pages/ProjectDetail";
import BrandSettings from "./pages/BrandSettings";
import Timeline from "./pages/Timeline";
import Team from "./pages/Team";
import ProjectsList from "./pages/ProjectsList";
import PublicProject from "./pages/PublicProject";
import ClientPortalLogin from "./pages/ClientPortalLogin";
import ClientPortalDashboard from "./pages/ClientPortalDashboard";
import Integrations from "./pages/Integrations";
import Opportunities from "./pages/Opportunities";
import Quotes from "./pages/Quotes";
import Adempimenti from "./pages/Adempimenti";
import Agenda from "./pages/Agenda";
import Timesheet from "./pages/Timesheet";
import Pratiche from "./pages/Pratiche";
import Documents from "./pages/Documents";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/public/:token" element={<PublicProject />} />
            <Route path="/portal" element={<ClientPortalLogin />} />
            <Route path="/portal/verify" element={<ClientPortalDashboard />} />
            <Route element={<Protected><AppLayout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/projects" element={<ProjectsList />} />
              <Route path="/projects/new" element={<ProjectNew />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/timeline" element={<Timeline />} />
              <Route path="/team" element={<Team />} />
              <Route path="/brand" element={<BrandSettings />} />
              <Route path="/integrations" element={<Integrations />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/quotes" element={<Quotes />} />
              <Route path="/adempimenti" element={<Adempimenti />} />
              <Route path="/agenda" element={<Agenda />} />
              <Route path="/timesheet" element={<Timesheet />} />
              <Route path="/pratiche" element={<Pratiche />} />
              <Route path="/documents" element={<Documents />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
